module.exports = __webpack_public_path__ + "img/left-arrow.5b4d074c.svg";